import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromVirtualScroll from './virtual-scroll.reducer';

export const selectVirtualScrollState = createFeatureSelector<fromVirtualScroll.State>(
  fromVirtualScroll.virtualScrollFeatureKey
);

export const selectInViewport = createSelector(selectVirtualScrollState, (state) => state.inViewport);
export const selectHasRendered = createSelector(selectVirtualScrollState, (state) => state.hasRendered);
export const selectUserScrolled = createSelector(selectVirtualScrollState, (state) => state.userHasScrolled);

/**
 * Returns true if all the visible charts have finished rendering
 * they need to be in the viewport, and have rendered
 * this would return true if none are in the viewport as well
 */
export const selectViewportRendered = createSelector(selectInViewport, selectHasRendered, (inViewport, hasRendered) => {
  return Object.keys(inViewport).every((token) => {
    return (inViewport[token] === true && hasRendered[token] === true) || inViewport[token] === false;
  });
});

export function createVizInViewportSelector(token: string) {
  return createSelector(selectInViewport, (state) => state[token]);
}

export function createVizRenderedSelector(token: string) {
  return createSelector(selectHasRendered, (state) => state[token]);
}
